import React, { ReactNode } from 'react';
import cx from 'clsx';

import style from './index.module.css';

type CardProps = {
  className?: string;
  children?: ReactNode;
  shadow?: boolean;
} & React.HTMLProps<HTMLDivElement>;

export const Card = ({ children, className, shadow, ...rest }: CardProps) => {
  return (
    <div className={cx(style.card, shadow && style.isShadow, className)} {...rest}>
      {children}
    </div>
  );
};
